import styles from "./TestimonialSection.module.css";

const TestimonialSection = () => {
  return (
    <section className={styles.testimonialSection}>
      <div className={styles.leftContent}>
        <h2 className={styles.heading}>
          Trusted by Recruiters <br /> Worldwide
        </h2>
        <p className={styles.subText}>
          Hear what our partners have to say about their success with{" "}
          <span className={styles.highlight}>ToxBox AI</span>
        </p>
      </div>

      <div className={styles.card}>
        <div className={styles.quoteIcon}>❝</div>
        <p className={styles.review}>
          <span className={styles.bold}>ToxBox AI</span> cut our resume
          screening time by 70%! The candidate ranking is precise, and the
          integration with our ATS is seamless.
        </p>

        <div className={styles.cardFooter}>
          <img
            src="/images/user1.jpg"
            alt="Savannah Nguyen"
            className={styles.avatar}
          />
          <div>
            <p className={styles.userName}>Savannah Nguyen</p>
            <p className={styles.userRole}>HR Manager, Global Tech Firm</p>
          </div>
        </div>

        <button className={styles.arrowBtn}>›</button>
      </div>
    </section>
  );
};

export default TestimonialSection;
